import { AbstractPmsApiService } from "./abstract.service";
import { BaladyApiLog } from "../models";

/**
 * @class BaladyApiLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BaladyApiLog>}
 */
export class BaladyApiLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/balady-api-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BaladyApiLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BaladyApiLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<BaladyApiLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/balady-api-log.service.js